import React, { useCallback, useState } from 'react';
import cn from 'classnames';
import { observer, calculatorState as store } from 'store';
import Title from 'components/UI/Title';
import Subtitle from 'components/UI/Subtitle';
import DesktopBlock from '../DesktopBlock';
import { useTrans } from 'utils/localisation';
import * as styles from './DesktopSection.module.scss';

function DesktopSection({
  calculatorID,
  blockType,
  counterType,
  type,
  name: sectionName,
  defaultValue,
  shouldShowHints,
  title,
  subtitle,
  additionalSubtitle,
  items,
  showMoreButton,
  options,
  initialStep,
  wrapperBoxesCN,
  fullWidth = true,
  borderBottom = true,
  withMT = false,
  lastRow = false,
  cols,
  index,
}) {
  const { updateElementInfo, updateCurrentList, togglePreview, getCounterInfo } = store;

  const [isExpand, setExpand] = useState(false);
  const changeCountHandler = useCallback(
    (key, value) => {
      updateElementInfo(calculatorID, sectionName, key, value);
      updateCurrentList(calculatorID, sectionName, key, value);
      togglePreview(calculatorID, true);
    },
    [calculatorID, sectionName],
  );

  const onShowMore = useCallback(() => setExpand(!isExpand), [isExpand]);

  const getCounterValue = key => {
    return getCounterInfo(calculatorID, sectionName, key);
  };
  const t = useTrans(['calculator']);

  return (
    <section
      className={cn(
        fullWidth ? styles.section : styles.twoColumnsSection,
        borderBottom && styles.borderBottom,
        withMT && styles.withMT,
        lastRow && styles.lastRow,
      )}
    >
      {title && (
        <Title tag="p" size="h4" className={styles.title}>
          {title}
        </Title>
      )}
      {subtitle && (
        <Subtitle className={styles.subtitle} size="md">
          {subtitle}
        </Subtitle>
      )}
      {additionalSubtitle && (
        <Subtitle className={styles.subtitle} size="md">
          {additionalSubtitle}
        </Subtitle>
      )}
      <div className={cn(styles.wrapper, wrapperBoxesCN && styles[wrapperBoxesCN])}>
        <div className={cn(styles.boxes, showMoreButton && !isExpand && styles.shrink)}>
          <DesktopBlock
            type={type}
            blockType={blockType}
            counterType={counterType}
            calculatorID={calculatorID}
            sectionName={sectionName}
            onChangeCount={changeCountHandler}
            initialStep={initialStep}
            options={options}
            defaultValue={defaultValue}
            items={items}
            getCounterValue={getCounterValue}
            shouldShowHints={shouldShowHints}
            cols={cols}
            sectionIndex={index}
          />
        </div>
        {showMoreButton && (
          <div className={styles.footer}>
            <button className={styles.showAll} onClick={onShowMore}>
              {t('showAll')}
            </button>
          </div>
        )}
      </div>
    </section>
  );
}

export default observer(DesktopSection);
